import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import { useDashboardStats } from '@features/ownedParkingManage/hooks/useDashboardStats';

type DashboardStatsContextValue = ReturnType<typeof useDashboardStats>;

const DashboardStatsContext = createContext<DashboardStatsContextValue | undefined>(undefined);

export function DashboardStatsProvider({ children }: { children: ReactNode }) {
  const stats = useDashboardStats();

  return <DashboardStatsContext value={stats}>{children}</DashboardStatsContext>;
}

export function useDashboardStatsContext(): DashboardStatsContextValue {
  const context = useContext(DashboardStatsContext);
  if (context === undefined) {
    throw new Error('useDashboardStatsContext must be used within DashboardStatsProvider');
  }
  return context;
}
